<template>
	<el-drawer :visible.sync="data.show" :before-close="handleClose" size="449px" append-to-body>
		<template #title>
			<div class="title_header">
				<p>{{ data.title || $t("查看码单") }}</p>
			</div>
		</template>

		<div class="image-ul row aic fww pl15 w100">
			<template v-for="(item, index) in data.img_arr">
				<div
					:key="index"
					v-if="!is_del_index.some((i) => i == index)"
					class="image_div"
					:style="{
						marginRight: '12px'
					}"
				>
					<el-image
						class="image-li"
						:src="data.ordinary ? item : item[data.imgKey || 'actual_purchase_image']"
						:preview-src-list="
							data.ordinary ? data.img_arr : data.img_arr.map((i) => i[data.imgKey || 'actual_purchase_image'])
						"
						fit="fill"
					>
						<div slot="error" class="image-slot">
							<i class="iconfont icon-a-icon-emptypic"></i></div
					></el-image>

					<!-- 删除图标 -->
					<i class="iconfont icon-a-cuowuguanbi-tianchong" @click="deleteImg(index)" v-if="data.edit"></i>
					<!-- 已录状态 -->
					<p
						class="image-status"
						:style="{
							backgroundColor: item.code_status == 1 ? '#2C68FF' : '#969EAB'
						}"
						v-if="!data.ordinary"
					>
						{{ item.code_status == 1 ? $t("已录") : $t("未录") }}
					</p>
				</div></template
			>
		</div>
		<footer v-if="data.edit">
			<el-button @click="handleClose" size="small">{{ $t(" 取 消 ") }}</el-button>
			<el-button type="primary" @click="save" size="small">{{ $t(" 保 存 ") }}</el-button>
		</footer>
		<!-- <footer v-else>
      <el-button @click="handleClose" size="small"> 关 闭 </el-button>
    </footer> -->
	</el-drawer>
</template>
<script>
export default {
	props: {
		data: {
			type: Object,
			default() {
				return {
					title: "",
					show: false,
					img_arr: [],
					ordinary: false, //普通
					edit: true, //是否可编辑
					imgKey: "actual_purchase_image"
				};
			}
		}
	},
	data() {
		return {
			is_del_index: [] //已删除的索引
		};
	},

	methods: {
		handleClose() {
			this.data.show = false;
		},
		save() {
			// 把数组已删除的数组索引由大到小排序传给父级
			this.$emit(
				"change",
				this.is_del_index.sort((a, b) => b - a)
			);
			this.handleClose();
		},
		deleteImg(index) {
			this.is_del_index.push(index);
		}
	}
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
	padding: 16px 16px;
	margin-bottom: 16px;
	border-bottom: 1px solid #eee;
	.title_header {
		display: flex;
		align-items: center;
		padding-right: 15px;
		justify-content: space-between;

		p {
			color: #080c0c;
			font-weight: 700;
		}
	}
}
footer {
	border-top: 1px solid #eee;
	position: absolute;
	bottom: 0;
	right: 0;
	height: 56px;
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: flex-end;
	padding-right: 20px;
}
.image-ul {
	.image_div {
		position: relative;
		.image-li {
			width: 96px;
			height: 96px;
			border-radius: 2px;
			::v-deep .image-slot {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				i {
					font-size: 45px;
					opacity: 0.6399999857;
					display: block;
				}
			}
		}
		.icon-a-cuowuguanbi-tianchong {
			right: 0px;
			top: 0px;
			font-size: 16px;
			position: absolute;
			color: #2d3743;
			cursor: pointer;
			z-index: 1;
		}
		.image-status {
			position: absolute;
			top: 4px;
			left: 0;
			color: #fff;
			height: 16px;
			line-height: 16px;
			font-size: 12px;
		}
	}
	.image-num {
		margin-left: 12px;
		font-size: 12px;
		color: #2c68ff;
	}
}
</style>
